import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {CompanyStandardForm} from 'src/app/compliance-standards/CompanyStandardForm';
import {ComplianceStandardsBrowserShell} from 'src/app/compliance-standards/ComplianceStandardsBrowserShell';
import {complianceTreeRootId} from 'src/app/compliance-standards/complianceStandardTreeState';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const CreateCustomComplianceStandardPage = () => {
  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Compliance}>
      <ComplianceStandardsBrowserShell
        variant="company"
        selectedId={complianceTreeRootId}>
        <CompanyStandardForm mode="create" />
      </ComplianceStandardsBrowserShell>
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.CustomComplianceStandardsCreate(),
  element: <CreateCustomComplianceStandardPage />,
  module: ModuleEnum.Compliance,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default CreateCustomComplianceStandardPage;
